import { defineMessages } from 'react-intl';

/** design: trial-upsell b4 (the offer) and the "gets" lines of b3. Product copy from the frames. */
export const watermarkOfferMessages = defineMessages({
  lede: {
    id: 'app.sml.upsell.watermark.offer.lede',
    defaultMessage: 'Your music, your name. No mark of a tool on the posts that your fans see.',
  },
  getCopies: {
    id: 'app.sml.upsell.watermark.offer.get.copies',
    defaultMessage: 'Clean copies of your {count, plural, one {# file} other {# files}}',
  },
  getCopiesNote: {
    id: 'app.sml.upsell.watermark.offer.get.copies.note',
    defaultMessage: 'We make them again after the payment. You pay no credits.',
  },
  getCopiesNoteTakeover: {
    id: 'app.sml.upsell.watermark.offer.get.copies.noteTakeover',
    defaultMessage: 'Made for you after the payment. No credits.',
  },
  getFullSize: { id: 'app.sml.upsell.watermark.offer.get.fullSize', defaultMessage: 'Full size' },
  getFullSizeNote: {
    id: 'app.sml.upsell.watermark.offer.get.fullSize.note',
    defaultMessage: '1080 × 1920, not the 540 × 960 preview.',
  },
  getNew: { id: 'app.sml.upsell.watermark.offer.get.new', defaultMessage: 'No watermark on each new file' },
  getPosts: {
    id: 'app.sml.upsell.watermark.offer.get.posts',
    defaultMessage: '{count, plural, one {Your # post goes out clean} other {Your # posts go out clean}}',
  },
  getNewName: {
    id: 'app.sml.upsell.watermark.offer.get.newName',
    defaultMessage: 'Each new file with only your name on it',
  },
  planDetailLimited: {
    id: 'app.sml.upsell.watermark.offer.plan.limited',
    defaultMessage:
      '{credits} video credits a month, {releases, plural, one {# active release} other {# active releases}}',
  },
  planDetailFull: {
    id: 'app.sml.upsell.watermark.offer.plan.full',
    defaultMessage: 'Full-song videos, {credits} video credits, every release',
  },
  needsPro: {
    id: 'app.sml.upsell.watermark.offer.needsPro',
    defaultMessage: 'Your full-song videos need {plan}.',
  },
  fine: { id: 'app.sml.upsell.watermark.offer.fine', defaultMessage: 'Cancel at any time.' },
  fineTrial: {
    id: 'app.sml.upsell.watermark.offer.fine.trial',
    defaultMessage: 'Cancel at any time. Your trial limits stay until {date}.',
  },
  memberLede: {
    id: 'app.sml.upsell.watermark.offer.member.lede',
    defaultMessage: 'A plan removes it from the {count, plural, one {# file} other {# files}} of this workspace.',
  },
  memberLedeNoFiles: {
    id: 'app.sml.upsell.watermark.offer.member.ledeNoFiles',
    defaultMessage: 'A plan removes it from the files of this workspace.',
  },
  memberLedeNew: {
    id: 'app.sml.upsell.watermark.offer.member.ledeNew',
    defaultMessage: 'A plan makes each new file of this workspace with no watermark.',
  },
  copyForOwner: {
    id: 'app.sml.upsell.watermark.offer.member.copy',
    defaultMessage: 'Copy a message for the owner',
  },
  ownerMessage: {
    id: 'app.sml.upsell.watermark.offer.member.message',
    defaultMessage:
      'Our MUSIC24 files have the MUSIC24 watermark. A plan removes it. Can you upgrade the workspace? {url}',
  },
  copied: { id: 'app.sml.upsell.watermark.offer.member.copied', defaultMessage: 'The message is copied.' },
});
